import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { configChart } from "./configChart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const GraphicLine = ({ title, data }) => {
  const config = configChart(title);

  const labels = Object.keys(data).reverse();

  const result = {
    labels,
    datasets: [
      {
        label: "ItensContratos",
        data: labels.map((label) => data[label].ItensContratos.length),
        borderColor: "rgb(59, 235, 53)",
        backgroundColor: "rgba(53, 235, 62, 0.5)",
      },
      {
        label: "Mapas",
        data: labels.map((label) => data[label].Mapas.length),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  return <Line options={config.options} data={result} />;
};

export { GraphicLine };
